import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@emotion/react";
import router from "./Routes/Route";
import theme from "./Theme/customeTheme";
import { SnackbarProvider } from "notistack";
import { CssBaseline } from '@mui/material';
 
 
const App = () => {
 
  return (
    <SnackbarProvider maxSnack={1}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={router} />
      </ThemeProvider>
    </SnackbarProvider>
  );
}
 
export default App;
 
 
